<template>
  <div
    v-bind="attributeId"
    class="toolbar-section"
    :class="className"
    :style="style"
  >
    <slot name="sectionContent" />
  </div>
</template>

<script lang="ts" setup>
  import { toRefs, computed, useAttrs, StyleValue } from 'vue';

  interface ToolbarSectionProps {
    style?: StyleValue;
    className?: string;
  }

  const props = defineProps<ToolbarSectionProps>();
  const { style, className } = toRefs(props);

  const attributeId = () => {
    const attrs = useAttrs();
    return typeof attrs.id === 'object' ? attrs.id : {};
  };
</script>
